import { useEffect, useRef, useState } from 'react';

import { verifyEmail } from '../api/verify-email';

export type VerifyEmailStatus = 'verifying' | 'verified' | 'expired' | 'failed';

export function useVerifyEmailOnMount(token: string): VerifyEmailStatus {
    const [status, setStatus] = useState<VerifyEmailStatus>('verifying');
    // Tracks the last token consumed so the request fires once per distinct token — this both
    // skips StrictMode's double-invoke and re-runs if the token prop changes without a remount.
    const lastTokenRef = useRef<string | null>(null);

    useEffect(() => {
        if (lastTokenRef.current === token) return;
        lastTokenRef.current = token;

        setStatus('verifying');

        void (async () => {
            const result = await verifyEmail(token);
            if (result.ok) {
                setStatus('verified');
                return;
            }
            setStatus(result.code === 'EXPIRED' ? 'expired' : 'failed');
        })();
    }, [token]);

    return status;
}
